module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av176-43e3954e99542d80d227c40ef4949547.jpg";